import * as React from 'react';
import {StyleSheet, TouchableOpacity} from 'react-native';
import { View, Text, Image } from 'react-native';
import {useNavigation} from "@react-navigation/native";


export default function CredentialItem({Credential, Name}) {
    const navigation = useNavigation();

    return (
        <TouchableOpacity style={styles.cardContainer} onPress={() => navigation.navigate('Credential') }>
            <View style={styles.tag}>
                <View style={styles.side}></View>
            </View>
            <View style={styles.card}>
                <Text style={styles.text4}>{Credential}</Text>
                <View style={styles.textView}>
                    <Text style={styles.text5}>{Name}</Text>
                </View>
            </View>
        </TouchableOpacity>
    );
}

const styles = StyleSheet.create({
    text4: {
        fontSize: 12,
        fontWeight: '500',
        color: 'whitesmoke',
        marginLeft: 15,
        marginBottom: 20,
    },
    text5: {
        fontSize: 10,
        color: '#a7a7a7',
    },
    textView: {
        backgroundColor: 'black',
        marginLeft: 15,
        marginTop: 35,
        width: 90,
        height: 20,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
    },
    card: {
        width: '100%',
        height: '100%',
        backgroundColor: '#2C69C8',
        justifyContent: 'space-around',
        alignItems: 'flex-start',
        borderRadius: 5,
    },
    cardContainer: {
        flexDirection: 'row',
        width: 130,
        height: 160,
        justifyContent: 'space-around',
        alignItems: 'center',
        borderRadius: 5,
        marginRight: 20,
        marginLeft: 20,
    },
    tag: {
        width: 4,
        height: '100%',
    },
    side: {
        width: '100%',
        height: 20,
        backgroundColor: 'black',
        top: 20,
    },

});
